module.exports = "<span>&copy; {{settings.app.year}} - Inovocom (Pty) Ltd</span>"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/layout/footer/footer.component.html
// module id = ../../../../../src/app/layout/footer/footer.component.html
// module chunks = main